/**
 * LeaveNotificationQueueService
 * Service for LeaveNotificationQueue entity operations
 * Route: api/leavenotificationqueue
 */
import { CrudService } from '../base/CrudService';
/**
 * LeaveNotificationQueueService
 * Handles leave notification queue CRUD operations
 */
export class LeaveNotificationQueueService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LeaveNotificationQueueService.DEFAULT_SERVICE_PATH,
            basePath: LeaveNotificationQueueService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
LeaveNotificationQueueService.DEFAULT_SERVICE_PATH = 'hr';
LeaveNotificationQueueService.BASE_PATH = 'api/leavenotificationqueue';
//# sourceMappingURL=LeaveNotificationQueueService.js.map